import { render, staticRenderFns } from "./MappingConfigCompoment.vue?vue&type=template&id=55683c60"
import script from "./MappingConfigCompoment.vue?vue&type=script&lang=js"
export * from "./MappingConfigCompoment.vue?vue&type=script&lang=js"
import style0 from "./MappingConfigCompoment.vue?vue&type=style&index=0&id=55683c60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports